module.exports = __webpack_public_path__ + "static/media/dice-d20.2e0a46d6.svg";